import { MessageCircle } from "lucide-react";
import { WHATSAPP } from "../data/siteData";
import { trackEvent } from "../lib/analytics";

export const WhatsAppFloat = () => {
  return (
    <a
      href={WHATSAPP.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent("whatsapp_click", { location: "floating_button" })}
      data-testid="whatsapp-float-btn"
      aria-label="Chat with Thrive on WhatsApp"
      className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-teal-dark text-white flex items-center justify-center shadow-xl shadow-teal-dark/30 transition-all duration-200 hover:-translate-y-1 hover:bg-[#1C565E] focus:outline-none focus:ring-2 focus:ring-teal focus:ring-offset-2"
    >
      <MessageCircle className="w-6 h-6" strokeWidth={2.25} />
    </a>
  );
};
